module.exports = __webpack_public_path__ + "static/media/Screenshot--sheetMusic.3ce3940e.png";